module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"importance":"Bedeutung","audititem":"Auditfrage","category":"Kategorie","chapter":"Kapitel","use_template":"Vorlage nutzen","pdf_export":"Frageliste drucken"},"en":{"importance":"Importance","audititem":"Auditquestion","category":"Category","chapter":"Chapter","use_template":"Use Template","pdf_export":"Print questionlist"}}')
  delete Component.options._Ctor
}
